import React from "react";
import SvgIconComponent from "../utils/SvgIconComponent";

function CalendarIcon({className, color, size}) {
  return (
    <SvgIconComponent size={size} color={color}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          // fill="#9B9B9F"
          d="M0 20.4C0 22.44 1.56 24 3.6 24h16.8c2.04 0 3.6-1.56 3.6-3.6v-9.6H0v9.6zm20.4-18H18V1.2c0-.72-.48-1.2-1.2-1.2s-1.2.48-1.2 1.2v1.2H8.4V1.2C8.4.48 7.92 0 7.2 0S6 .48 6 1.2v1.2H3.6C1.56 2.4 0 3.96 0 6v2.4h24V6c0-2.04-1.56-3.6-3.6-3.6z"
        ></path>
      </svg>
    </SvgIconComponent>
  );
}

export default CalendarIcon;